import { useMutation, useQuery } from '@tanstack/react-query';
import { Col, Form, Row } from 'antd';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { generalConfigApi } from '../../../../apis';
import { TimekeepingSettingsValueDto } from '../../../../apis/client-axios';
import ButtonWrap from '../../../../components/ButtonWrap';
import InputWrap from '../../../../components/InputWrap';
import ToastError from '../../../../components/Toast/ToastError';
import ToastSuccess from '../../../../components/Toast/ToastSuccess';
import Widget from '../../../../components/Widget';
import { TIME_API } from '../../../../constants/QueryKey';
import './style.scss';

const TimeCorrection = () => {
  const intl = useIntl();
  const [form] = Form.useForm();

  const { data: timeData, refetch } = useQuery({
    queryKey: [TIME_API],
    queryFn: () => generalConfigApi.generalConfigControllerGetTimeKeepingSettings(),
  });

  useEffect(() => {
    if (timeData?.data?.data) {
      form.setFieldsValue(timeData?.data?.data);
    }
  }, [timeData?.data.data]);

  const timeMutation = useMutation({
    mutationFn: (payload: TimekeepingSettingsValueDto) =>
      generalConfigApi.generalConfigControllerUpsertTimeKeepingSettings(payload),
    onSuccess: () => {
      refetch();
      ToastSuccess({
        content: intl.formatMessage({ id: 'holiday.noti.success' }),
      });
    },
    onError: () => {
      refetch();
      ToastError({
        content: intl.formatMessage({ id: 'holiday.noti.fail' }),
      });
    },
  });

  const onFinish = (formValues: TimekeepingSettingsValueDto) => {
    timeMutation.mutate(formValues);
  };

  return (
    <>
      <Widget
        breadcrumbs={[intl.formatMessage({ id: 'time.correction.breadcum' })]}
        content={
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Row gutter={[16, 16]} className="time-correction">
              <Col span={24} className="time-correction-title">
                {intl.formatMessage({ id: 'time.correction.content.title' })}
              </Col>
              <Col span={24}>
                <Row gutter={[16, 16]} align="middle">
                  <Col>{intl.formatMessage({ id: 'time.correction.content.editTime' })}</Col>
                  <Col>
                    <Form.Item
                      name="timeKeepingEditLimit"
                      className="mb-0"
                      rules={[
                        { required: true, message: '' },
                        { whitespace: true, message: '' },
                        { pattern: /^[1-9]\d*$/, message: '' },
                      ]}
                    >
                      <InputWrap maxLength={255} width={68} height={40} className="time-correction-input" />
                    </Form.Item>
                  </Col>
                  <Col>{intl.formatMessage({ id: 'time.correction.content.date' })}</Col>
                </Row>
              </Col>
            </Row>
            <ButtonWrap htmlType="submit" width={162} height={48} disabled={timeMutation.isPending} className="ms-auto">
              {intl.formatMessage({ id: 'common.save' })}
            </ButtonWrap>
          </Form>
        }
        title={intl.formatMessage({ id: 'time.correction.title' })}
      />
    </>
  );
};
export default TimeCorrection;
